<template>
  <tr>
    <td>
      <a-popover v-if="isMine" placement="rightBottom">
        <template slot="content">
          <p>
            고객님께서
            <b>등록하신 도매</b>입니다.
          </p>
          <p>다른 사용자는 수정할 수 없습니다.</p>
        </template>
        <a-button type="dashed" shape="circle" size="small">
          {{
          this.$vnode.key + 1
          }}
        </a-button>
      </a-popover>
      <p v-else>{{ this.$vnode.key + 1 }}</p>
    </td>
    <td v-if="isPC">{{ name }}</td>
    <td v-if="isPC">
      <b>{{ location.building }}</b>
      <br />
      ({{ location.mall }})
    </td>
    <td v-if="isPC">
      <a-badge
        :count="`${location.floor}층 ${location.row}열 ${location.place}호`"
        :numberStyle="{ backgroundColor: '#52c41a' }"
      />
    </td>
    <td v-if="isPC">
      <a :href="`tel://${phone}`">{{ phone }}</a>
    </td>
    <td v-if="isPC">
      <a :href="`tel://${mobile}`">{{ mobile }}</a>
    </td>
    <td v-if="isPC">
      <a-button shape="circle" icon="edit" @click="checkBeforeEdit(idx)" />
    </td>
    <td v-if="isPC">
      <a-button shape="circle" icon="delete" @click="deleteWholesale(idx)" />
    </td>
    <td v-if="!isPC" style="text-align: left;">
      <dl>
        <dt>매장 이름:</dt>
        <dd>{{ name }}</dd>
        <dt>위치:</dt>
        <dd>{{ location.building }} ({{ location.mall }})</dd>
        <dt>층/열/호:</dt>
        <dd>{{ `${location.floor}층 ${location.row}열 ${location.place}호` }}</dd>
        <dt>전화번호:</dt>
        <dd>
          <a class="ant-btn" :href="`tel://${phone}`" style="color: #000;">{{ phone }}</a>
        </dd>
        <dt>휴대폰 번호:</dt>
        <dd>
          <a class="ant-btn" :href="`tel://${mobile}`" style="color: #000;">{{ mobile }}</a>
        </dd>
        <dt>수정 또는 삭제</dt>
        <dd>
          <a-button shape="circle" icon="edit" @click="checkBeforeEdit(idx)" />
          <a-button
            shape="circle"
            style="margin-left: 10px;"
            icon="delete"
            @click="deleteWholesale(idx)"
          />
        </dd>
      </dl>
    </td>
  </tr>
</template>
<script>
import { mapActions } from "vuex";
import Axios from "axios";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import Config from "@/config";

export default {
  name: "WholesaleItem",
  props: ["idx", "name", "location", "phone", "mobile", "isMine"],
  methods: {
    ...mapActions(["deleteWholesale", "editWholesale"]),
    async checkBeforeEdit(idx) {
      const { data } = await Axios.get(
        `${Config.hostname}/v1/wholesale/edit/${idx}`,
        {
          withCredentials: true
        }
      );

      if (AxiosMiddleware(data.opcode)) {
        const self = this;
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            if (!data.canEdit) {
              this.$confirm({
                title: "편집 불가",
                content:
                  "다른 사용자가 생성한 도매이므로 수정할 수 없습니다." +
                  "이와 동일한 도매를 복제하여 수정하시겠습니까?",
                okText: "네, 복제합니다.",
                cancelText: "아니요",
                onOk() {
                  self.editWholesale({ idx, isDup: true });
                }
              });
            } else {
              self.editWholesale({ idx, isDup: false });
            }
            break;
        }
      }
    }
  }
};
</script>
